export default "__VITE_ASSET__DeMv4O4R__"